<!----------------- BEGIN TS ---------------------->
<script lang="ts">
import { initPopover } from "@/plugins/bootstrapSetup";
import { Popover } from "bootstrap";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class TheAccessControlToggleButton extends Vue {
  // ---------- Props ----------

  /** Whether or not access control is showing */
  @Prop() showAccessControl!: boolean;

  /** Show the map only if the lat and lng is not 0 and all fields exist. */
  @Prop() canShowAtAll!: boolean;

  // ------- Local Vars --------

  /** Reference to all popovers so we can modify them (Note that in this component, there is only one). */
  popovers!: Popover[];

  // --------- Watchers --------

  @Watch("showAccessControl")
  setDynamicHelpMessage(): void {
    // Need to essentially delete and rebuild because otherwise popover content doesn't change
    if (this.popovers) {
      // NOTE: there is only one, but this is for robustness
      this.popovers.forEach((popover) => {
        popover.dispose();
      });
      this.popovers = initPopover(
        this.$refs.accessControlButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // ------- Lifecycle ---------

  mounted(): void {
    if (this.$refs.accessControlButton) {
      this.popovers = initPopover(
        this.$refs.accessControlButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // --------- Methods ---------

  /** Choose an icon based on the state. */
  get chooseIcon(): string[] {
    if (this.showAccessControl) {
      return ["door-open"];
    } else {
      return ["door-closed"];
    }
  }

  /** Gets the dynamic help message. */
  get dynamicHelpMessage(): string {
    if (this.showAccessControl) {
      return "Hide Access Control Events.";
    } else {
      return "Show Access Control Events.";
    }
  }
}
</script>
<!----------------- END TS ------------------------>

<!----------------- BEGIN HTML -------------------->
<template lang="html">
  <div
    class="the-access-control-toggle-button-container"
    ref="accessControlButton"
    v-if="canShowAtAll"
  >
    <button
      type="button"
      class="btn btn-light access-toggle-button text-dark"
      @click="$emit('update-access-state')"
      data-bs-toggle="popover"
      data-bs-trigger="hover"
      data-bs-container="#app-container"
      data-bs-html="true"
      :data-bs-content="`<span>${dynamicHelpMessage}</span>`"
    >
      <b-iconstack class="icon" font-scale="2">
        <b-icon
          stacked
          v-for="(icon, index) in chooseIcon"
          :key="`icon-${index}`"
          :icon="icon"
          :scale="index > 0 ? '2.5' : '.85'"
        ></b-icon>
      </b-iconstack>
    </button>
  </div>
</template>
<!----------------- END HTML ---------------------->

<!----------------- BEGIN SCSS -------------------->
<style scoped lang="scss">
// Override SCSS Classes here
.the-access-control-toggle-button-container {
  display: flex;
  margin-left: auto;

  .access-toggle-button {
    box-shadow: 4px 7px 4px 0px rgb(0 0 0 / 25%);
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
    font-size: 14px;
    max-height: 71px;

    .icon {
      width: 30px;
      @media only screen and (max-width: 600px),
        screen and (max-height: 550px) {
        width: 20px;
      }

      @media only screen and (max-width: 500px),
        screen and (max-height: 400px) {
        width: 10px;
      }
    }
  }
}
</style>
<!----------------- END SCSS ---------------------->
